import { trackEvent } from "../../../trackEvent";

// Determine banner_name from an <img> inside the link: prefer alt, then title, else filename from src
const getBannerNameFromLink = (anchor) => {
  if (!anchor) return "";
  const img = anchor.querySelector("img");
  if (!img) {
    const text = anchor.textContent?.trim();
    return text || "";
  }

  const alt = img.getAttribute("alt")?.trim();
  const title = img.getAttribute("title")?.trim();
  const src = img.getAttribute("src")?.trim() || "";

  if (alt) return alt;
  if (title) return title;

  if (src) {
    const withoutQuery = src.split("?")[0].split("#")[0];
    const segments = withoutQuery.split("/");
    try {
      return decodeURIComponent(segments[segments.length - 1] || "");
    } catch (e) {
      return segments[segments.length - 1] || "";
    }
  }

  return "";
};

const test = ({ target }) => !!target.closest(".hero--container a");

const push = ({ link, target }) => {
  const anchor = target?.closest("a") || null;
  const href = link;
  const bannerName = getBannerNameFromLink(anchor);

  trackEvent({
    event: "click_banner",
    ...(bannerName && { banner_name: bannerName }),
    event_type: "click",
    element_url: href,
  });
};

export default {
  name: "banner",
  test,
  push,
};

